import { ol_ImageLayer, ol_Coordinate, ol_Feature, ol_source, ol_layer } from "@omnia/exports/openlayers";
import { GcpContext } from "./gcp-context";
import { GcpMap } from "./gcp-map";
import { GcpPoint } from "./gcp-point";


export class SourceRasterMap extends GcpMap {


    private rasterLayer: ol_ImageLayer;

    constructor(gcpContext: GcpContext) {
        super(gcpContext, false);
    }

    public addNewPoint(coord: ol_Coordinate): GcpPoint {
        return this.context.addPoint(coord, true);
    }

    public getPointFeature(point: GcpPoint): ol_Feature {
        return point.raster;
    }

    public setupEditor(rasterUrl: string, rasterWidth: number, rasterHeight: number) {

        if (this.rasterLayer) {
            this.olmap.removeLayer(this.rasterLayer);
        }

        let extent = [0, 0, rasterWidth, rasterHeight];

        let source = new ol_source.ImageStatic({
            url: rasterUrl,
            imageExtent: extent,
        });

        this.rasterLayer = new ol_layer.Image({
            source: source
        });

        this.olmap.getLayers().insertAt(0, this.rasterLayer);

        this.viewExtent(extent, () => {

            let view = this.olmap.getView();
            let zoom = view.getZoom();
            view.setZoom(zoom + 1);

        });

    }


    public setupMap(targetElement: HTMLElement) {

        super.setupMap(targetElement);

        this.rasterLayer = new ol_layer.Image(<any>{});
        this.olmap.addLayer(this.rasterLayer);

        this.olmap.addLayer(this.pointsLayer);

    }
}
